<template>
  <side-panel-inner headerTitle="Create an Interest Group" class="p-group-create" on-close="Groups">
    <template slot="actions">
      <base-button :primary="true" @click="createGroup">Create</base-button>
    </template>

    <!-- Group Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <form v-if="!loading">
      <form-field full-width label="Group Name" name="group_name" v-model="group.name"></form-field>
    </form>

    <loading v-else></loading>
  </side-panel-inner>
</template>

<script>
export default {
  name: "group-create",

  data() {
    return {
      showValidationMessage: false,
      loading: false,
      group: {
        name: null
      }
    };
  },

  methods: {
    createGroup() {
      this.$store.dispatch("InterestGroups/create", this.group).then(() => {
        this.$store.dispatch("CLOSE_PANEL");
      });
    }
  },

  computed: {
    formIsValid() {
      return this.group.name;
    }
  }
};
</script>
